/**
 * Google Fonts catalogue — GENERATED, do not edit by hand.
 * Run `node scripts/generate-font-catalog.mjs` to refresh.
 *
 * Rows are [family, categoryIndex, weightMask, scriptMask]; see fonts/index.js
 * for the decoder and scripts/generate-font-catalog.mjs for the encoding.
 *
 * Generated from https://fonts.google.com/metadata/fonts
 * Families: 1942
 */
export const CATEGORIES = ["Sans Serif","Serif","Display","Handwriting","Monospace"];

export const SCRIPTS = [["bengali","Bengali"],["devanagari","Devanagari"],["arabic","Arabic"],["cyrillic","Cyrillic"],["greek","Greek"],["hebrew","Hebrew"],["japanese","Japanese"],["korean","Korean"],["chinese-simplified","Chinese (Simplified)"],["chinese-traditional","Chinese (Traditional)"],["thai","Thai"],["tamil","Tamil"],["telugu","Telugu"],["vietnamese","Vietnamese"]];

export const FAMILY_ROWS = [
["ABeeZee",0,4104,0],
["Abel",0,8,0],
["Abhaya Libre",1,248,0],
["Aboreto",2,8,0],
["Abril Fatface",2,8,0],
["Abyssinica SIL",1,8,0],
["Aclonica",0,8,0],
["Acme",0,8,0],
["Actor",0,8,0],
["Adamina",1,8,0],
["ADLaM Display",2,8,0],
["Advent Pro",0,262143,24],
["Afacad",0,61560,8192],
["Afacad Flux",0,511,8192],
["Agbalumo",2,8,8192],
["Agdasima",0,72,0],
["Agu Display",2,8,8192],
["Aguafina Script",3,8,0],
["Akatab",0,504,0],
["Akaya Kanadaka",2,8,0],
["Akaya Telivigala",2,8,4096],
["Akronim",2,8,0],
["Akshar",0,124,2],
["Akt",0,511,8216],
["Aladin",2,8,0],
["Alan Sans",0,508,0],
["Alata",0,8,8192],
["Alatsi",0,8,8192],
["Albert Sans",0,262143,0],
["Aldrich",0,8,0],
["Alef",0,72,32],
["Alegreya",1,258552,8216],
["Alegreya Sans",0,244701,8216],
["Alegreya Sans SC",0,244701,8216],
["Alegreya SC",1,242136,8216],
["Aleo",1,262143,8192],
["Alex Brush",3,8,8192],
["Alexandria",0,511,8196],
["Alfa Slab One",2,8,8192],
["Alice",1,8,8],
["Alien Block",2,8,0],
["Alike",1,8,0],
["Alike Angular",1,8,0],
["Alkalami",1,8,4],
["Alkatra",2,120,3],
["Allan",2,72,0],
["Allerta",0,8,0],
["Allerta Stencil",0,8,0],
["Allison",3,8,8192],
["Allkin",2,8,0],
["Allura",3,8,8192],
["Almarai",0,204,4],
["Almendra",1,36936,0],
["Almendra Display",2,8,0],
["Almendra SC",1,8,0],
["Alumni Sans",0,262143,8200],
["Alumni Sans Collegiate One",0,4104,8200],
["Alumni Sans Inline One",2,4104,8192],
["Alumni Sans Pinstripe",0,4104,8200],
["Alumni Sans SC",0,262143,8200],
["Alyamama",1,508,20],
["Amarante",2,8,0],
["Amaranth",0,36936,0],
["Amarna",0,65151,0],
["Amatic SC",3,72,8232],
["Amethysta",1,8,0],
["Amiko",0,104,2],
["Amiri",1,36936,4],
["Amiri Quran",1,8,4],
["Amita",3,72,2],
["Anaheim",0,248,8192],
["Ancizar Sans",0,262143,16],
["Ancizar Serif",1,260604,16],
["Andada Pro",1,127224,8192],
["Andika",0,36936,8200],
["Anek Bangla",0,255,1],
["Anek Devanagari",0,255,2],
["Anek Gujarati",0,255,0],
["Anek Gurmukhi",0,255,0],
["Anek Kannada",0,255,0],
["Anek Latin",0,255,8192],
["Anek Malayalam",0,255,0],
["Anek Odia",0,255,0],
["Anek Tamil",0,255,2048],
["Anek Telugu",0,255,4096],
["Angkor",2,8,0],
["Annapurna SIL",1,72,2],
["Annie Use Your Telescope",3,8,0],
["Anonymous Pro",4,36936,24],
["Anta",0,8,0],
["Antic",0,8,0],
["Antic Didone",1,8,0],
["Antic Slab",1,8,0],
["Anton",0,8,8192],
["Anton SC",0,8,8192],
["Antonio",0,127,0],
["Anuphan",0,127,9216],
["Anybody",2,262143,8192],
["Aoboshi One",1,8,64],
["AR One Sans",0,120,8192],
["Arapey",1,4104,0],
["Arbutus",1,8,0],
["Arbutus Slab",1,8,0],
["Architects Daughter",3,8,0],
["Archivo",0,262143,8192],
["Archivo Black",0,8,0],
["Archivo Narrow",0,61560,8192],
["Are You Serious",3,8,8192],
["Aref Ruqaa",1,72,4],
["Aref Ruqaa Ink",1,72,4],
["Arima",2,127,10256],
["Arimo",0,61560,8248],
["Arizonia",3,8,8192],
["Armata",0,8,0],
["Arsenal",0,36936,8200],
["Arsenal SC",0,36936,8200],
["Artifika",1,8,0],
["Arvo",1,36936,0],
["Arya",0,72,2],
["Asap",0,262143,8192],
["Asap Condensed",0,261630,8192],
["Asar",1,8,2],
["Asimovian",0,8,8192],
["Asset",2,8,0],
["Assistant",0,254,32],
["Asta Sans",0,252,128],
["Astloch",2,72,0],
["Asul",1,72,0],
["Athiti",0,126,9216],
["Atkinson Hyperlegible",0,36936,0],
["Atkinson Hyperlegible Mono",0,130302,0],
["Atkinson Hyperlegible Next",0,130302,0],
["Atma",2,124,1],
["Atomic Age",2,8,0],
["Aubrey",2,8,0],
["Audiowide",2,8,0],
["Autour One",2,8,0],
["Average",1,8,0],
["Average Sans",0,8,0],
["Averia Gruesa Libre",2,8,0],
["Averia Libre",2,38988,0],
["Averia Sans Libre",2,38988,0],
["Averia Serif Libre",2,38988,0],
["Azeret Mono",4,262143,0],
["B612",0,36936,0],
["B612 Mono",4,36936,0],
["Babylonica",3,8,8192],
["Bacasime Antique",1,8,0],
["Bad Script",3,8,8200],
["Badeen Display",2,8,4],
["Bagel Fat One",2,8,128],
["Bahiana",2,8,0],
["Bahianita",2,8,8192],
["Bai Jamjuree",0,64638,9216],
["Bakbak One",2,8,2],
["Ballet",3,8,8192],
["Baloo 2",2,248,8194],
["Baloo Bhai 2",2,248,8192],
["Baloo Bhaijaan 2",2,248,8196],
["Baloo Bhaina 2",2,248,8192],
["Baloo Chettan 2",2,248,8192],
["Baloo Da 2",2,248,8193],
["Baloo Paaji 2",2,248,8192],
["Baloo Tamma 2",2,248,8192],
["Baloo Tammudu 2",2,248,12288],
["Baloo Thambi 2",2,248,10240],
["Balsamiq Sans",2,36936,8],
["Balthazar",1,8,0],
["Bangers",2,8,8192],
["Barlow",0,262143,8192],
["Barlow Condensed",0,262143,8192],
["Barlow Semi Condensed",0,262143,8192],
["Barriecito",2,8,8192],
["Barrio",2,8,0],
["Basic",0,8,0],
["Baskervville",1,61560,0],
["Baskervville SC",1,120,0],
["Battambang",2,333,0],
["Baumans",2,8,0],
["Bayon",0,8,0],
["BBH Bartle",0,8,0],
["BBH Bogle",0,8,0],
["BBH Hegarty",0,8,0],
["Be Vietnam Pro",0,262143,8192],
["Beau Rivage",3,8,8192],
["Bebas Neue",0,8,0],
["Beiruti",0,510,8196],
["Belanosima",0,104,0],
["Belgrano",1,8,0],
["Bellefair",1,8,32],
["Belleza",0,8,0],
["Bellota",2,38988,8200],
["Bellota Text",2,38988,8200],
["BenchNine",0,76,0],
["Benne",1,8,0],
["Bentham",1,8,0],
["Berkshire Swash",3,8,0],
["Besley",1,258552,0],
["Betania Patmos",3,8,0],
["Betania Patmos GDL",3,8,0],
["Betania Patmos In",3,8,0],
["Betania Patmos In GDL",3,8,0],
["Beth Ellen",3,8,0],
["Bevan",1,4104,8192],
["BhuTuka Expanded One",1,8,0],
["Big Shoulders",2,511,8192],
["Big Shoulders Inline",2,511,8192],
["Big Shoulders Stencil",2,511,8192],
["Bigelow Rules",2,8,0],
["Bigshot One",2,8,0],
["Bilbo",3,8,8192],
["Bilbo Swash Caps",3,8,0],
["BioRhyme",1,254,0],
["BioRhyme Expanded",1,206,0],
["Birthstone",3,8,8192],
["Birthstone Bounce",3,24,8192],
["Biryani",0,494,2],
["Bitcount",2,511,0],
["Bitcount Grid Double",2,511,0],
["Bitcount Grid Double Ink",2,511,0],
["Bitcount Grid Single",2,511,0],
["Bitcount Grid Single Ink",2,511,0],
["Bitcount Ink",2,511,0],
["Bitcount Prop Double",2,511,0],
["Bitcount Prop Double Ink",2,511,0],
["Bitcount Prop Single",2,511,0],
["Bitcount Prop Single Ink",2,511,0],
["Bitcount Single",2,511,0],
["Bitcount Single Ink",2,511,0],
["Bitter",1,262143,8200],
["BIZ UDGothic",0,72,72],
["BIZ UDMincho",1,72,72],
["BIZ UDPGothic",0,72,72],
["BIZ UDPMincho",1,72,72],
["BJCree",1,120,0],
["Black And White Picture",2,8,128],
["Black Han Sans",0,8,128],
["Black Ops One",2,8,8192],
["Blaka",2,8,4],
["Blaka Hollow",2,8,4],
["Blaka Ink",2,8,4],
["Blinker",0,495,0],
["Bodoni Moda",1,258552,0],
["Bodoni Moda SC",1,258552,0],
["Bokor",2,8,0],
["Boldonse",2,8,0],
["Bona Nova",1,4168,8248],
["Bona Nova SC",1,4168,8248],
["Bonbon",3,8,0],
["Bonheur Royale",3,8,8192],
["Boogaloo",2,8,0],
["Borel",3,8,8192],
["Bowlby One",2,8,0],
["Bowlby One SC",2,8,0],
["Bpmf Huninn",0,8,512],
["Bpmf Iansui",3,8,512],
["Bpmf Zihi Kai Std",0,8,512],
["Braah One",0,8,8192],
["Brawler",1,72,0],
["Bree Serif",1,8,0],
["Bricolage Grotesque",0,254,8192],
["Bruno Ace",2,8,0],
["Bruno Ace SC",2,8,0],
["Brygada 1918",1,61560,8216],
["Bubblegum Sans",2,8,0],
["Bubbler One",0,8,0],
["Buda",2,4,0],
["Buenard",1,120,0],
["Bungee",2,8,8192],
["Bungee Hairline",2,8,8192],
["Bungee Inline",2,8,8192],
["Bungee Outline",2,8,8192],
["Bungee Shade",2,8,8192],
["Bungee Spice",2,8,8192],
["Bungee Tint",2,8,8192],
["Butcherman",2,8,0],
["Butterfly Kids",3,8,0],
["Bytesized",0,8,0],
["Cabin",0,61560,8192],
["Cabin Condensed",0,120,8192],
["Cabin Sketch",2,72,0],
["Cactus Classical Serif",1,8,8712],
["Caesar Dressing",2,8,0],
["Cagliostro",0,8,0],
["Cairo",0,510,4],
["Cairo Play",0,510,4],
["Cal Sans",0,8,8192],
["Caladea",1,36936,0],
["Calistoga",2,8,8192],
["Calligraffitti",3,8,0],
["Cambay",0,36936,2],
["Cambo",1,8,0],
["Candal",0,8,0],
["Cantarell",0,36936,0],
["Cantata One",1,8,0],
["Cantora One",0,8,0],
["Caprasimo",2,8,0],
["Capriola",0,8,0],
["Caramel",3,8,8192],
["Carattere",3,8,8192],
["Cardo",1,4168,48],
["Carlito",0,36936,8216],
["Carme",0,8,0],
["Carrois Gothic",0,8,0],
["Carrois Gothic SC",0,8,0],
["Carter One",2,8,0],
["Cascadia Code",0,64638,8252],
["Cascadia Mono",0,64638,8252],
["Castoro",1,4104,0],
["Castoro Titling",2,8,0],
["Catamaran",0,511,2048],
["Caudex",1,36936,8208],
["Cause",3,511,0],
["Caveat",3,120,8],
["Caveat Brush",3,8,0],
["Cedarville Cursive",3,8,0],
["Ceviche One",2,8,0],
["Chakra Petch",0,63612,9216],
["Changa",0,254,4],
["Changa One",2,4104,0],
["Chango",2,8,0],
["Charis SIL",1,36936,8200],
["Charm",3,72,9216],
["Charmonman",3,72,9216],
["Chathura",0,205,4096],
["Chau Philomene One",0,4104,0],
["Chela One",2,8,0],
["Chelsea Market",2,8,0],
["Chenla",2,8,0],
["Cherish",3,8,8192],
["Cherry Bomb One",2,8,8256],
["Cherry Cream Soda",2,8,0],
["Cherry Swash",2,72,0],
["Chewy",2,8,0],
["Chicle",2,8,0],
["Chilanka",3,8,0],
["Chiron GoRound TC",0,510,8712],
["Chiron Hei HK",0,261630,8728],
["Chiron Sung HK",1,261630,8216],
["Chivo",0,262143,8192],
["Chivo Mono",4,262143,8192],
["Chocolate Classical Sans",0,8,8712],
["Chokokutai",2,8,8256],
["Chonburi",2,8,9216],
["Cinzel",1,504,0],
["Cinzel Decorative",2,328,0],
["Clicker Script",3,8,0],
["Climate Crisis",2,8,8],
["Coda",2,136,0],
["Codystar",2,12,0],
["Coiny",2,8,10240],
["Combo",2,8,0],
["Comfortaa",2,124,8216],
["Comforter",3,8,8200],
["Comforter Brush",3,8,8200],
["Comic Neue",3,38988,0],
["Comic Relief",2,72,24],
["Coming Soon",3,8,0],
["Comme",0,511,0],
["Commissioner",0,511,8216],
["Concert One",2,8,0],
["Condiment",3,8,0],
["Content",2,72,0],
["Contrail One",2,8,0],
["Convergence",0,8,0],
["Cookie",3,8,0],
["Copse",1,8,0],
["Coral Pixels",2,8,0],
["Corben",2,72,0],
["Corinthia",3,72,8192],
["Cormorant",1,63612,8200],
["Cormorant Garamond",1,63612,8200],
["Cormorant Infant",1,63612,8200],
["Cormorant SC",1,124,8200],
["Cormorant Unicase",1,124,8200],
["Cormorant Upright",1,124,8192],
["Cossette Texte",0,72,0],
["Cossette Titre",0,72,0],
["Courgette",3,8,0],
["Courier Prime",4,36936,0],
["Cousine",4,36936,8248],
["Coustard",1,264,0],
["Covered By Your Grace",3,8,0],
["Crafty Girls",3,8,0],
["Creepster",2,8,0],
["Crete Round",1,4104,0],
["Crimson Pro",1,261630,8192],
["Crimson Text",1,53352,8192],
["Croissant One",2,8,0],
["Crushed",2,8,0],
["Cuprum",0,61560,8200],
["Cute Font",2,8,128],
["Cutive",1,8,0],
["Cutive Mono",4,8,0],
["Dai Banna SIL",1,63612,0],
["Damion",3,8,0],
["Dancing Script",3,120,8192],
["Danfo",1,8,8192],
["Dangrek",2,8,0],
["Darker Grotesque",0,508,8192],
["Darumadrop One",2,8,64],
["Datatype",4,511,0],
["David Libre",1,88,8224],
["Dawning of a New Day",3,8,0],
["Days One",0,8,8],
["Dekko",3,8,2],
["Dela Gothic One",2,8,8280],
["Delicious Handrawn",3,8,0],
["Delius",3,8,0],
["Delius Swash Caps",3,8,0],
["Delius Unicase",3,72,0],
["Della Respira",1,8,0],
["Denk One",0,8,8192],
["Devonshire",3,8,0],
["Dhurjati",0,8,4096],
["Didact Gothic",0,8,24],
["Diphylleia",1,8,128],
["Diplomata",2,8,0],
["Diplomata SC",2,8,0],
["DM Mono",4,14364,0],
["DM Sans",0,262143,0],
["DM Serif Display",1,4104,0],
["DM Serif Text",1,4104,0],
["Do Hyeon",0,8,128],
["Dokdo",2,8,128],
["Domine",1,120,0],
["Donegal One",1,8,0],
["Dongle",0,76,8320],
["Doppio One",0,8,0],
["Dorsa",0,8,0],
["Dosis",0,254,8192],
["DotGothic16",0,8,72],
["Doto",0,511,0],
["Dr Sugiyama",3,8,0],
["Duru Sans",0,8,0],
["Dynalight",2,8,0],
["DynaPuff",2,120,0],
["Eagle Lake",3,8,0],
["East Sea Dokdo",3,8,128],
["Eater",2,8,0],
["EB Garamond",1,127224,8216],
["Economica",0,36936,0],
["Eczar",1,248,18],
["Edu AU VIC WA NT Arrows",3,120,0],
["Edu AU VIC WA NT Dots",3,120,0],
["Edu AU VIC WA NT Guides",3,120,0],
["Edu AU VIC WA NT Hand",3,120,0],
["Edu AU VIC WA NT Pre",3,120,0],
["Edu NSW ACT Cursive",3,120,0],
["Edu NSW ACT Foundation",3,120,0],
["Edu NSW ACT Hand Pre",3,120,0],
["Edu QLD Beginner",3,120,0],
["Edu QLD Hand",3,120,8192],
["Edu SA Beginner",3,120,0],
["Edu SA Hand",3,120,0],
["Edu TAS Beginner",3,120,0],
["Edu VIC WA NT Beginner",3,120,0],
["Edu VIC WA NT Hand",3,120,0],
["Edu VIC WA NT Hand Pre",3,120,0],
["El Messiri",0,120,12],
["Electrolize",0,8,0],
["Elms Sans",0,262143,8192],
["Elsie",2,264,0],
["Elsie Swash Caps",2,264,0],
["Emblema One",2,8,0],
["Emilys Candy",2,8,0],
["Encode Sans",0,511,8192],
["Encode Sans Condensed",0,511,8192],
["Encode Sans Expanded",0,511,8192],
["Encode Sans SC",0,511,8192],
["Encode Sans Semi Condensed",0,511,8192],
["Encode Sans Semi Expanded",0,511,8192],
["Engagement",3,8,0],
["Englebert",0,8,0],
["Enriqueta",1,120,0],
["Ephesis",3,8,8192],
["Epilogue",0,262143,8192],
["Epunda Sans",0,260604,0],
["Epunda Slab",1,260604,0],
["Erica One",2,8,0],
["Esteban",1,8,0],
["Estedad",0,511,8196],
["Estonia",3,8,8192],
["Euphoria Script",3,8,0],
["Ewert",2,8,0],
["Exile",2,8,0],
["Exo",0,262143,8192],
["Exo 2",0,262143,8200],
["Expletus Sans",2,61560,0],
["Explora",3,8,8192],
["Faculty Glyphic",0,8,0],
["Fahkwang",0,64638,9216],
["Familjen Grotesk",0,61560,8192],
["Fanwood Text",1,4104,0],
["Farro",0,92,0],
["Farsan",2,8,8192],
["Fascinate",2,8,0],
["Fascinate Inline",2,8,0],
["Faster One",2,8,0],
["Fasthand",2,8,0],
["Fauna One",1,8,0],
["Faustina",1,129276,8192],
["Federant",2,8,0],
["Federo",0,8,0],
["Felipa",3,8,0],
["Fenix",1,8,0],
["Festive",3,8,8192],
["Figtree",0,260604,0],
["Finger Paint",2,8,0],
["Finlandica Headline",0,262143,8200],
["Finlandica Text",0,262143,8200],
["Fira Code",4,124,24],
["Fira Mono",4,88,24],
["Fira Sans",0,262143,8216],
["Fira Sans Condensed",0,262143,8216],
["Fira Sans Extra Condensed",0,262143,8216],
["Fjalla One",0,8,8192],
["Fjord One",1,8,0],
["Flamenco",2,12,0],
["Flavors",2,8,0],
["Fleur De Leah",3,8,8192],
["Flow Block",2,8,8200],
["Flow Circular",2,8,8200],
["Flow Rounded",2,8,8200],
["Foldit",2,511,8192],
["Fondamento",3,4104,0],
["Fontdiner Swanky",2,8,0],
["Forum",2,8,8],
["Fragment Mono",4,4104,0],
["Francois One",0,8,8192],
["Frank Ruhl Libre",1,508,32],
["Fraunces",1,262143,8192],
["Freckle Face",2,8,0],
["Fredericka the Great",2,8,0],
["Fredoka",0,124,32],
["Freehand",2,8,0],
["Freeman",2,8,8192],
["Fresca",0,8,0],
["Frijole",2,8,0],
["Fruktur",2,4104,8192],
["Fugaz One",2,8,0],
["Fuggles",3,8,8192],
["Funnel Display",2,252,0],
["Funnel Sans",0,129276,0],
["Fustat",0,254,4],
["Fuzzy Bubbles",3,72,8192],
["Ga Maamli",2,8,8192],
["Gabarito",2,504,0],
["Gabriela",1,8,8],
["Gaegu",3,76,128],
["Gafata",0,8,0],
["Gajraj One",2,8,2],
["Galada",2,8,1],
["Galdeano",0,8,0],
["Galindo",2,8,0],
["Gamja Flower",3,8,128],
["Gantari",0,262143,0],
["Gasoek One",0,8,128],
["Gayathri",0,73,0],
["Geist",0,262143,8200],
["Geist Mono",4,262143,8200],
["Geist Pixel",2,8,0],
["Gelasio",1,61560,8192],
["Gemunu Libre",0,254,0],
["Genos",0,262143,8192],
["Gentium Book Plus",1,36936,8216],
["Gentium Plus",1,36936,8216],
["Geo",0,4104,0],
["Geologica",0,511,8216],
["Geom",0,260604,16],
["Geomini",0,254,0],
["Georama",0,262143,8192],
["Geostar",2,8,0],
["Geostar Fill",2,8,0],
["Germania One",2,8,0],
["GFS Didot",1,8,8208],
["GFS Neohellenic",0,36936,8208],
["Gideon Roman",2,8,8192],
["Gidole",0,8,8216],
["Gidugu",0,8,4096],
["Gilda Display",1,8,0],
["Girassol",2,8,0],
["Give You Glory",3,8,0],
["Glass Antiqua",2,8,0],
["Glegoo",1,72,2],
["Gloock",1,8,0],
["Gloria Hallelujah",3,8,0],
["Glory",0,130815,8192],
["Gluten",2,511,8192],
["Goblin One",2,8,0],
["Gochi Hand",3,8,0],
["Goldman",2,72,8192],
["Golos Text",0,504,8],
["Google Sans",0,61560,15419],
["Google Sans Code",4,129276,8192],
["Google Sans Flex",0,511,8192],
["Gorditas",2,72,0],
["Gothic A1",0,511,8344],
["Gotu",0,8,8194],
["Goudy Bookletter 1911",1,8,0],
["Gowun Batang",1,72,8320],
["Gowun Dodum",0,8,8320],
["Graduate",1,8,0],
["Grand Hotel",3,8,0],
["Grandiflora One",1,8,128],
["Grandstander",2,262143,8192],
["Grape Nuts",3,8,8192],
["Gravitas One",2,8,0],
["Great Vibes",3,8,8200],
["Grechen Fuemen",3,8,8192],
["Grenze",1,262143,8192],
["Grenze Gotisch",2,511,8192],
["Grey Qo",3,8,8192],
["Griffy",2,8,0],
["Gruppo",0,8,0],
["Gudea",0,4168,0],
["Gugi",2,8,128],
["Gulzar",1,8,4],
["Gupter",1,88,0],
["Gurajada",0,8,4096],
["Gveret Levin",3,8,32],
["Gwendolyn",3,72,8192],
["Habibi",1,8,0],
["Hachi Maru Pop",3,8,72],
["Hahmlet",1,511,8320],
["Halant",1,124,2],
["Hammersmith One",0,8,0],
["Hanalei",2,8,0],
["Hanalei Fill",2,8,0],
["Handjet",2,511,8252],
["Handlee",3,8,0],
["Hanken Grotesk",0,262143,8192],
["Hanuman",1,511,0],
["Happy Monkey",2,8,0],
["Harmattan",0,120,4],
["Headland One",1,8,0],
["Hedvig Letters Sans",0,8,0],
["Hedvig Letters Serif",1,8,0],
["Heebo",0,511,32],
["Henny Penny",2,8,0],
["Hepta Slab",1,511,8192],
["Herr Von Muellerhoff",3,8,0],
["Hi Melody",3,8,128],
["Hibur Mono",4,8,0],
["Hina Mincho",1,8,8264],
["Hind",0,124,2],
["Hind Guntur",0,124,4096],
["Hind Madurai",0,124,2048],
["Hind Mysuru",0,124,0],
["Hind Siliguri",0,124,1],
["Hind Vadodara",0,124,0],
["Holtwood One SC",1,8,0],
["Homemade Apple",3,8,0],
["Homenaje",0,8,0],
["Honk",2,8,8192],
["Host Grotesk",0,129276,0],
["Hubballi",0,8,0],
["Hubot Sans",0,261630,8192],
["Huninn",0,8,8712],
["Hurricane",3,8,8192],
["Iansui",3,8,512],
["Ibarra Real Nova",1,61560,0],
["IBM Plex Mono",4,65151,8200],
["IBM Plex Sans",0,65151,8216],
["IBM Plex Sans Arabic",0,127,4],
["IBM Plex Sans Condensed",0,65151,8192],
["IBM Plex Sans Devanagari",0,127,2],
["IBM Plex Sans Hebrew",0,127,32],
["IBM Plex Sans JP",0,127,72],
["IBM Plex Sans KR",0,127,128],
["IBM Plex Sans Thai",0,127,1024],
["IBM Plex Sans Thai Looped",0,127,1024],
["IBM Plex Serif",1,65151,8200],
["Iceberg",2,8,0],
["Iceland",2,8,0],
["Idiqlat",1,14,0],
["IM Fell Double Pica",1,4104,0],
["IM Fell Double Pica SC",1,8,0],
["IM Fell DW Pica",1,4104,0],
["IM Fell DW Pica SC",1,8,0],
["IM Fell English",1,4104,0],
["IM Fell English SC",1,8,0],
["IM Fell French Canon",1,4104,0],
["IM Fell French Canon SC",1,8,0],
["IM Fell Great Primer",1,4104,0],
["IM Fell Great Primer SC",1,8,0],
["Imbue",1,511,8192],
["Imperial Script",3,8,8192],
["Imprima",0,8,0],
["Inclusive Sans",0,63612,8192],
["Inconsolata",4,510,8192],
["Inder",0,8,0],
["Indie Flower",3,8,0],
["Ingrid Darling",3,8,8192],
["Inika",1,72,0],
["Inknut Antiqua",1,508,2],
["Inria Sans",0,38988,0],
["Inria Serif",1,38988,0],
["Inspiration",3,8,8192],
["Instrument Sans",0,61560,0],
["Instrument Serif",1,4104,0],
["Intel One Mono",4,63612,8192],
["Inter",0,262143,8216],
["Inter Tight",0,262143,8216],
["Iosevka Charon",4,47196,8216],
["Iosevka Charon Mono",4,47196,8216],
["Irish Grover",2,8,0],
["Island Moments",3,8,8192],
["Istok Web",0,36936,8],
["Italiana",0,8,0],
["Italianno",3,8,8192],
["Itim",3,8,9216],
["Jacquard 12",2,8,0],
["Jacquard 12 Charted",2,8,0],
["Jacquard 24",2,8,0],
["Jacquard 24 Charted",2,8,0],
["Jacquarda Bastarda 9",2,8,0],
["Jacquarda Bastarda 9 Charted",2,8,0],
["Jacques Francois",1,8,0],
["Jacques Francois Shadow",2,8,0],
["Jaini",2,8,2],
["Jaini Purva",2,8,2],
["Jaldi",0,72,2],
["Jaro",0,8,8192],
["Jersey 10",2,8,0],
["Jersey 10 Charted",2,8,0],
["Jersey 15",2,8,0],
["Jersey 15 Charted",2,8,0],
["Jersey 20",2,8,0],
["Jersey 20 Charted",2,8,0],
["Jersey 25",2,8,0],
["Jersey 25 Charted",2,8,0],
["JetBrains Mono",4,130815,8216],
["Jim Nightshade",3,8,0],
["Joan",1,8,0],
["Jockey One",0,8,0],
["Jolly Lodger",2,8,0],
["Jomhuria",2,8,4],
["Jomolhari",1,8,0],
["Josefin Sans",0,65151,8192],
["Josefin Slab",1,65151,0],
["Jost",0,262143,8],
["Joti One",2,8,0],
["Jua",0,8,128],
["Judson",1,4168,8192],
["Julee",3,8,0],
["Julius Sans One",0,8,0],
["Junge",1,8,0],
["Jura",0,124,8216],
["Just Another Hand",3,8,0],
["Just Me Again Down Here",3,8,0],
["K2D",0,130815,9216],
["Kablammo",2,8,8200],
["Kadwa",1,72,2],
["Kaisei Decol",1,88,72],
["Kaisei HarunoUmi",1,88,72],
["Kaisei Opti",1,88,72],
["Kaisei Tokumin",1,216,72],
["Kalam",3,76,2],
["Kalnia",1,127,0],
["Kalnia Glaze",2,127,0],
["Kameron",1,120,0],
["Kanchenjunga",0,120,0],
["Kanit",0,262143,9216],
["Kantumruy Pro",0,65151,0],
["Kapakana",3,12,64],
["Karantina",2,76,32],
["Karla",0,130302,0],
["Karla Tamil Inclined",0,72,2048],
["Karla Tamil Upright",0,72,2048],
["Karma",1,124,2],
["Katibeh",2,8,4],
["Kaushan Script",3,8,0],
["Kavivanar",3,8,2048],
["Kavoon",2,8,0],
["Kay Pho Du",1,120,0],
["Kdam Thmor Pro",0,8,0],
["Keania One",2,8,0],
["Kedebideri",0,504,0],
["Kelly Slab",2,8,8],
["Kenia",2,8,0],
["Khand",0,124,2],
["Khmer",0,8,0],
["Khula",0,236,2],
["Kings",3,8,8192],
["Kirang Haerang",2,8,128],
["Kite One",0,8,0],
["Kiwi Maru",1,28,72],
["Klee One",3,40,72],
["Knewave",2,8,0],
["Kodchasan",0,64638,9216],
["Kode Mono",4,120,0],
["Koh Santepheap",1,333,0],
["KoHo",0,64638,9216],
["Kolker Brush",3,8,8192],
["Konkhmer Sleokchher",2,8,0],
["Kosugi",0,8,72],
["Kosugi Maru",0,8,72],
["Kotta One",1,8,0],
["Koulen",2,8,0],
["Kranky",2,8,0],
["Kreon",1,124,0],
["Kristi",3,8,0],
["Krona One",0,8,0],
["Krub",0,64638,9216],
["Kufam",0,258552,8196],
["Kulim Park",0,56430,0],
["Kumar One",2,8,0],
["Kumar One Outline",2,8,0],
["Kumbh Sans",0,511,0],
["Kurale",1,8,10],
["La Belle Aurore",3,8,0],
["Labrada",1,262143,8192],
["Lacquer",2,8,0],
["Laila",1,124,2],
["Lakki Reddy",3,8,4096],
["Lalezar",0,8,8196],
["Lancelot",2,8,0],
["Langar",2,8,0],
["Lateef",1,254,4],
["Lato",0,170829,0],
["Lavishly Yours",3,8,8192],
["League Gothic",0,8,8192],
["League Script",3,8,0],
["League Spartan",0,511,8192],
["Leckerli One",3,8,0],
["Ledger",1,8,8],
["Lekton",4,4168,0],
["Lemon",2,8,0],
["Lemonada",2,124,8196],
["Lexend",0,511,8192],
["Lexend Deca",0,511,8192],
["Lexend Exa",0,511,8192],
["Lexend Giga",0,511,8192],
["Lexend Mega",0,511,8192],
["Lexend Peta",0,511,8192],
["Lexend Tera",0,511,8192],
["Lexend Zetta",0,511,8192],
["Libertinus Keyboard",2,8,0],
["Libertinus Math",2,8,0],
["Libertinus Mono",4,8,0],
["Libertinus Sans",0,4168,8216],
["Libertinus Serif",1,53352,8248],
["Libertinus Serif Display",2,8,8216],
["Libre Barcode 128",2,8,0],
["Libre Barcode 128 Text",2,8,0],
["Libre Barcode 39",2,8,0],
["Libre Barcode 39 Extended",2,8,0],
["Libre Barcode 39 Extended Text",2,8,0],
["Libre Barcode 39 Text",2,8,0],
["Libre Barcode EAN13 Text",2,8,0],
["Libre Baskerville",1,61560,0],
["Libre Bodoni",1,61560,8192],
["Libre Caslon Display",1,8,0],
["Libre Caslon Text",1,4168,0],
["Libre Franklin",0,262143,8200],
["Licorice",3,8,8192],
["Life Savers",2,200,0],
["Lilex",4,65151,8216],
["Lilita One",2,8,0],
["Lily Script One",2,8,0],
["Limelight",2,8,0],
["Linden Hill",1,4104,0],
["LINE Seed JP",0,201,72],
["Linefont",2,511,0],
["Lisu Bosa",1,261630,0],
["Liter",0,8,8],
["Literata",1,261630,8216],
["Liu Jian Mao Cao",3,8,256],
["Livvic",0,196479,8192],
["Lobster",2,8,8200],
["Lobster Two",2,36936,0],
["Londrina Outline",2,8,0],
["Londrina Shadow",2,8,0],
["Londrina Sketch",2,8,0],
["Londrina Solid",2,269,0],
["Long Cang",3,8,256],
["Lora",1,61560,8200],
["Love Light",3,8,8192],
["Love Ya Like A Sister",2,8,0],
["Loved by the King",3,8,0],
["Lovers Quarrel",3,8,8192],
["Luckiest Guy",2,8,0],
["Lugrasimo",3,8,0],
["Lumanosimo",3,8,0],
["Lunasima",0,72,8248],
["Lusitana",1,72,0],
["Lustria",1,8,0],
["Luxurious Roman",2,8,8192],
["Luxurious Script",3,8,8192],
["LXGW Marker Gothic",0,8,8728],
["LXGW WenKai Mono TC",4,76,8728],
["LXGW WenKai TC",3,76,8728],
["M PLUS 1",0,511,8256],
["M PLUS 1 Code",4,127,8256],
["M PLUS 1p",0,477,8312],
["M PLUS 2",0,511,8256],
["M PLUS Code Latin",0,127,8192],
["M PLUS Rounded 1c",0,477,8312],
["M PLUS U",0,511,8256],
["Ma Shan Zheng",3,8,256],
["Macondo",2,8,0],
["Macondo Swash Caps",2,8,0],
["Mada",0,510,4],
["Madimi One",0,8,0],
["Magra",0,72,0],
["Maiden Orange",1,8,0],
["Maitree",1,126,9216],
["Major Mono Display",4,8,8192],
["Mako",0,8,0],
["Mali",3,64638,9216],
["Mallanna",0,8,4096],
["Maname",1,8,8192],
["Mandali",0,8,4096],
["Manjari",0,73,0],
["Manrope",0,254,8216],
["Mansalva",3,8,8208],
["Manuale",1,129276,8192],
["Manufacturing Consent",2,8,0],
["Marcellus",1,8,0],
["Marcellus SC",1,8,0],
["Marck Script",3,8,8],
["Margarine",2,8,0],
["Marhey",2,124,4],
["Markazi Text",1,120,8196],
["Marko One",1,8,0],
["Marmelad",0,8,8200],
["Martel",1,494,2],
["Martel Sans",0,494,2],
["Martian Mono",4,255,8],
["Marvel",0,36936,0],
["Matangi",0,508,2],
["Mate",1,4104,0],
["Mate SC",1,8,0],
["Matemasie",0,8,0],
["Maven Pro",0,504,8192],
["McLaren",2,8,0],
["Mea Culpa",3,8,8192],
["Meddon",3,8,0],
["MedievalSharp",2,8,0],
["Medula One",2,8,0],
["Meera Inimai",0,8,2048],
["Megrim",2,8,0],
["Meie Script",3,8,0],
["Menbere",0,127,8192],
["Meow Script",3,8,8192],
["Merienda",3,508,8192],
["Merriweather",1,260604,8200],
["Merriweather Sans",0,129276,8192],
["Metal",2,8,0],
["Metal Mania",2,8,0],
["Metamorphous",2,8,0],
["Metrophobic",0,8,8192],
["Michroma",0,8,0],
["Micro 5",2,8,0],
["Micro 5 Charted",2,8,0],
["Milonga",2,8,0],
["Miltonian",2,8,0],
["Miltonian Tattoo",2,8,0],
["Mina",0,72,1],
["Mingzat",0,8,0],
["Miniver",2,8,0],
["Miranda Sans",0,61560,0],
["Miriam Libre",0,120,32],
["Mirza",1,120,4],
["Miss Fajardose",3,8,0],
["Mitr",0,126,9216],
["Mochiy Pop One",0,8,64],
["Mochiy Pop P One",0,8,64],
["Modak",2,8,2],
["Modern Antiqua",2,8,0],
["Moderustic",0,252,24],
["Mogra",2,8,0],
["Mohave",0,63612,0],
["Moirai One",2,8,128],
["Molengo",0,8,0],
["Molle",3,4096,0],
["Momo Signature",0,8,8192],
["Momo Trust Display",0,8,8192],
["Momo Trust Sans",0,254,8192],
["Mona Sans",0,261630,8192],
["Monda",0,120,8192],
["Monofett",4,8,0],
["Monomakh",2,8,8],
["Monomaniac One",0,8,64],
["Monoton",2,8,0],
["Monsieur La Doulaise",3,8,0],
["Montaga",1,8,0],
["Montagu Slab",1,127,8192],
["MonteCarlo",3,8,8192],
["Montenegrin Gothic One",1,8,0],
["Montez",3,8,0],
["Montserrat",0,262143,8200],
["Montserrat Alternates",0,262143,8200],
["Montserrat Underline",0,262143,8200],
["Moo Lah Lah",2,8,8192],
["Mooli",0,8,0],
["Moon Dance",3,8,8192],
["Moul",2,8,0],
["Moulpali",0,8,0],
["Mountains of Christmas",2,72,0],
["Mouse Memoirs",0,8,0],
["Mozilla Headline",0,126,0],
["Mozilla Text",0,126,0],
["Mr Bedfort",3,8,0],
["Mr Dafoe",3,8,0],
["Mr De Haviland",3,8,0],
["Mrs Saint Delafield",3,8,0],
["Mrs Sheppards",3,8,0],
["Ms Madi",3,8,8192],
["Mukta",0,254,2],
["Mukta Mahee",0,254,0],
["Mukta Malar",0,254,2048],
["Mukta Vaani",0,254,0],
["Mulish",0,261630,8200],
["Murecho",0,511,88],
["MuseoModerno",2,262143,8192],
["My Soul",3,8,8192],
["Mynerve",3,8,8208],
["Mystery Quest",2,8,0],
["Nabla",2,8,8192],
["Namdhinggo",1,248,0],
["Nanum Brush Script",3,8,128],
["Nanum Gothic",0,200,128],
["Nanum Gothic Coding",3,72,128],
["Nanum Myeongjo",1,200,128],
["Nanum Pen Script",3,8,128],
["Narnoor",0,248,0],
["Nata Sans",0,511,8200],
["National Park",0,254,8192],
["Neonderthaw",3,8,8192],
["Nerko One",3,8,0],
["Neucha",3,8,8],
["Neuton",1,4302,0],
["New Amsterdam",0,8,0],
["New Rocker",2,8,0],
["New Tegomin",1,8,64],
["News Cycle",0,72,8216],
["Newsreader",1,130302,8192],
["Niconne",3,8,0],
["Niramit",0,64638,9216],
["Nixie One",2,8,0],
["Nobile",0,45144,8],
["Nokora",0,511,0],
["Norican",3,8,0],
["Nosifer",2,8,0],
["Notable",0,8,0],
["Nothing You Could Do",3,8,0],
["Noticia Text",1,36936,8192],
["Noto Color Emoji",0,8,0],
["Noto Emoji",0,124,0],
["Noto Kufi Arabic",0,511,4],
["Noto Music",0,8,0],
["Noto Naskh Arabic",1,120,4],
["Noto Nastaliq Urdu",1,120,4],
["Noto Rashi Hebrew",1,511,32],
["Noto Sans",0,262143,8218],
["Noto Sans Adlam",0,120,0],
["Noto Sans Adlam Unjoined",0,120,0],
["Noto Sans Anatolian Hieroglyphs",0,8,0],
["Noto Sans Arabic",0,511,4],
["Noto Sans Armenian",0,511,0],
["Noto Sans Avestan",0,8,0],
["Noto Sans Balinese",0,120,0],
["Noto Sans Bamum",0,120,0],
["Noto Sans Bassa Vah",0,120,0],
["Noto Sans Batak",0,8,0],
["Noto Sans Bengali",0,511,1],
["Noto Sans Bhaiksuki",0,8,0],
["Noto Sans Brahmi",0,8,0],
["Noto Sans Buginese",0,8,0],
["Noto Sans Buhid",0,8,0],
["Noto Sans Canadian Aboriginal",0,511,0],
["Noto Sans Carian",0,8,0],
["Noto Sans Caucasian Albanian",0,8,0],
["Noto Sans Chakma",0,8,0],
["Noto Sans Cham",0,511,0],
["Noto Sans Cherokee",0,511,0],
["Noto Sans Chorasmian",0,8,0],
["Noto Sans Coptic",0,8,0],
["Noto Sans Cuneiform",0,8,0],
["Noto Sans Cypriot",0,8,0],
["Noto Sans Cypro Minoan",0,8,0],
["Noto Sans Deseret",0,8,0],
["Noto Sans Devanagari",0,511,2],
["Noto Sans Display",0,262143,8216],
["Noto Sans Duployan",0,72,0],
["Noto Sans Egyptian Hieroglyphs",0,8,0],
["Noto Sans Elbasan",0,8,0],
["Noto Sans Elymaic",0,8,0],
["Noto Sans Ethiopic",0,511,0],
["Noto Sans Georgian",0,511,0],
["Noto Sans Glagolitic",0,8,0],
["Noto Sans Gothic",0,8,0],
["Noto Sans Grantha",0,8,0],
["Noto Sans Gujarati",0,511,0],
["Noto Sans Gunjala Gondi",0,120,0],
["Noto Sans Gurmukhi",0,511,0],
["Noto Sans Hanifi Rohingya",0,120,0],
["Noto Sans Hanunoo",0,8,0],
["Noto Sans Hatran",0,8,0],
["Noto Sans Hebrew",0,511,32],
["Noto Sans HK",0,511,8200],
["Noto Sans Imperial Aramaic",0,8,0],
["Noto Sans Indic Siyaq Numbers",0,8,0],
["Noto Sans Inscriptional Pahlavi",0,8,0],
["Noto Sans Inscriptional Parthian",0,8,0],
["Noto Sans Javanese",0,120,0],
["Noto Sans JP",0,511,8264],
["Noto Sans Kaithi",0,8,0],
["Noto Sans Kannada",0,511,0],
["Noto Sans Kawi",0,120,0],
["Noto Sans Kayah Li",0,120,0],
["Noto Sans Kharoshthi",0,8,0],
["Noto Sans Khmer",0,511,0],
["Noto Sans Khojki",0,8,0],
["Noto Sans Khudawadi",0,8,0],
["Noto Sans KR",0,511,8328],
["Noto Sans Lao",0,511,0],
["Noto Sans Lao Looped",0,511,0],
["Noto Sans Lepcha",0,8,0],
["Noto Sans Limbu",0,8,0],
["Noto Sans Linear A",0,8,0],
["Noto Sans Linear B",0,8,0],
["Noto Sans Lisu",0,120,0],
["Noto Sans Lycian",0,8,0],
["Noto Sans Lydian",0,8,0],
["Noto Sans Mahajani",0,8,0],
["Noto Sans Malayalam",0,511,0],
["Noto Sans Mandaic",0,8,0],
["Noto Sans Manichaean",0,8,0],
["Noto Sans Marchen",0,8,0],
["Noto Sans Masaram Gondi",0,8,0],
["Noto Sans Math",0,8,0],
["Noto Sans Mayan Numerals",0,8,0],
["Noto Sans Medefaidrin",0,120,0],
["Noto Sans Meetei Mayek",0,511,0],
["Noto Sans Mende Kikakui",0,8,0],
["Noto Sans Meroitic",0,8,0],
["Noto Sans Miao",0,8,0],
["Noto Sans Modi",0,8,0],
["Noto Sans Mongolian",0,8,0],
["Noto Sans Mono",0,511,8216],
["Noto Sans Mro",0,8,0],
["Noto Sans Multani",0,8,0],
["Noto Sans Myanmar",0,511,0],
["Noto Sans Nabataean",0,8,0],
["Noto Sans Nag Mundari",0,120,0],
["Noto Sans Nandinagari",0,8,0],
["Noto Sans New Tai Lue",0,120,0],
["Noto Sans Newa",0,8,0],
["Noto Sans NKo",0,8,0],
["Noto Sans NKo Unjoined",0,120,0],
["Noto Sans Nushu",0,8,0],
["Noto Sans Ogham",0,8,0],
["Noto Sans Ol Chiki",0,120,0],
["Noto Sans Old Hungarian",0,8,0],
["Noto Sans Old Italic",0,8,0],
["Noto Sans Old North Arabian",0,8,0],
["Noto Sans Old Permic",0,8,0],
["Noto Sans Old Persian",0,8,0],
["Noto Sans Old Sogdian",0,8,0],
["Noto Sans Old South Arabian",0,8,0],
["Noto Sans Old Turkic",0,8,0],
["Noto Sans Oriya",0,511,0],
["Noto Sans Osage",0,8,0],
["Noto Sans Osmanya",0,8,0],
["Noto Sans Pahawh Hmong",0,8,0],
["Noto Sans Palmyrene",0,8,0],
["Noto Sans Pau Cin Hau",0,8,0],
["Noto Sans PhagsPa",0,8,0],
["Noto Sans Phoenician",0,8,0],
["Noto Sans Psalter Pahlavi",0,8,0],
["Noto Sans Rejang",0,8,0],
["Noto Sans Runic",0,8,0],
["Noto Sans Samaritan",0,8,0],
["Noto Sans Saurashtra",0,8,0],
["Noto Sans SC",0,511,8456],
["Noto Sans Sharada",0,8,0],
["Noto Sans Shavian",0,8,0],
["Noto Sans Siddham",0,8,0],
["Noto Sans SignWriting",0,8,0],
["Noto Sans Sinhala",0,511,0],
["Noto Sans Sogdian",0,8,0],
["Noto Sans Sora Sompeng",0,120,0],
["Noto Sans Soyombo",0,8,0],
["Noto Sans Sundanese",0,120,0],
["Noto Sans Sunuwar",0,8,0],
["Noto Sans Syloti Nagri",0,8,0],
["Noto Sans Symbols",0,511,0],
["Noto Sans Symbols 2",0,8,0],
["Noto Sans Syriac",0,511,0],
["Noto Sans Syriac Eastern",0,511,0],
["Noto Sans Syriac Western",0,511,0],
["Noto Sans Tagalog",0,8,0],
["Noto Sans Tagbanwa",0,8,0],
["Noto Sans Tai Le",0,8,0],
["Noto Sans Tai Tham",0,120,0],
["Noto Sans Tai Viet",0,8,0],
["Noto Sans Takri",0,8,0],
["Noto Sans Tamil",0,511,2048],
["Noto Sans Tamil Supplement",0,8,0],
["Noto Sans Tangsa",0,120,0],
["Noto Sans TC",0,511,8712],
["Noto Sans Telugu",0,511,4096],
["Noto Sans Thaana",0,511,0],
["Noto Sans Thai",0,511,1024],
["Noto Sans Thai Looped",0,511,1024],
["Noto Sans Tifinagh",0,8,0],
["Noto Sans Tirhuta",0,8,0],
["Noto Sans Ugaritic",0,8,0],
["Noto Sans Vai",0,8,0],
["Noto Sans Vithkuqi",0,120,0],
["Noto Sans Wancho",0,8,0],
["Noto Sans Warang Citi",0,8,0],
["Noto Sans Yi",0,8,0],
["Noto Sans Zanabazar Square",0,8,0],
["Noto Serif",1,262143,8216],
["Noto Serif Ahom",1,8,0],
["Noto Serif Armenian",1,511,0],
["Noto Serif Balinese",1,8,0],
["Noto Serif Bengali",1,511,1],
["Noto Serif Devanagari",1,511,2],
["Noto Serif Display",1,262143,8216],
["Noto Serif Dives Akuru",1,8,0],
["Noto Serif Dogra",1,8,0],
["Noto Serif Ethiopic",1,511,0],
["Noto Serif Georgian",1,511,0],
["Noto Serif Grantha",1,8,0],
["Noto Serif Gujarati",1,511,0],
["Noto Serif Gurmukhi",1,511,0],
["Noto Serif Hebrew",1,511,32],
["Noto Serif Hentaigana",1,510,0],
["Noto Serif HK",1,510,8200],
["Noto Serif JP",1,510,8264],
["Noto Serif Kannada",1,511,0],
["Noto Serif Khitan Small Script",1,8,0],
["Noto Serif Khmer",1,511,0],
["Noto Serif Khojki",1,120,0],
["Noto Serif KR",1,510,8328],
["Noto Serif Lao",1,511,0],
["Noto Serif Makasar",1,8,0],
["Noto Serif Malayalam",1,511,0],
["Noto Serif Myanmar",1,511,0],
["Noto Serif NP Hmong",1,120,0],
["Noto Serif Old Uyghur",1,8,0],
["Noto Serif Oriya",1,120,0],
["Noto Serif Ottoman Siyaq",1,8,0],
["Noto Serif SC",1,510,8456],
["Noto Serif Sinhala",1,511,0],
["Noto Serif Tamil",1,262143,2048],
["Noto Serif Tangut",1,8,0],
["Noto Serif TC",1,510,8712],
["Noto Serif Telugu",1,511,4096],
["Noto Serif Thai",1,511,1024],
["Noto Serif Tibetan",1,511,0],
["Noto Serif Todhri",1,8,0],
["Noto Serif Toto",1,120,0],
["Noto Serif Vithkuqi",1,120,0],
["Noto Serif Yezidi",1,120,0],
["Noto Traditional Nushu",0,124,0],
["Noto Znamenny Musical Notation",0,8,0],
["Nova Cut",2,8,0],
["Nova Flat",2,8,0],
["Nova Mono",4,8,16],
["Nova Oval",2,8,0],
["Nova Round",2,8,0],
["Nova Script",2,8,0],
["Nova Slim",2,8,0],
["Nova Square",2,8,0],
["NTR",0,8,4096],
["Numans",0,8,0],
["Nunito",0,261630,8200],
["Nunito Sans",0,261630,8200],
["Nuosu SIL",0,8,0],
["Odibee Sans",2,8,0],
["Odor Mean Chey",1,8,0],
["Offside",2,8,0],
["Oi",2,8,10268],
["Ojuju",0,254,8192],
["Old Standard TT",1,4168,8200],
["Oldenburg",2,8,0],
["Ole",3,8,8192],
["Oleo Script",2,72,0],
["Oleo Script Swash Caps",2,72,0],
["Onest",0,511,8],
["Oooh Baby",3,8,8192],
["Open Sans",0,129276,8248],
["Oranienbaum",1,8,8],
["Orbit",0,8,128],
["Orbitron",0,504,0],
["Oregano",2,4104,0],
["Orelega One",2,8,8],
["Orienta",0,8,0],
["Original Surfer",2,8,0],
["Oswald",0,126,8200],
["Outfit",0,511,0],
["Over the Rainbow",3,8,0],
["Overlock",2,168264,0],
["Overlock SC",2,8,0],
["Overpass",0,262143,8200],
["Overpass Mono",4,124,8200],
["Ovo",1,8,0],
["Oxanium",2,254,0],
["Oxygen",0,76,0],
["Oxygen Mono",4,8,0],
["Pacifico",3,8,8200],
["Padauk",0,72,0],
["Padyakke Expanded One",1,8,0],
["Palanquin",0,127,2],
["Palanquin Dark",0,120,2],
["Palette Mosaic",2,8,64],
["Pangolin",3,8,8200],
["Paprika",2,8,0],
["Parastoo",1,120,8196],
["Parisienne",3,8,0],
["Parkinsans",0,252,0],
["Passero One",2,8,0],
["Passion One",2,328,0],
["Passions Conflict",3,8,8192],
["Pathway Extreme",0,262143,8192],
["Pathway Gothic One",0,8,0],
["Patrick Hand",3,8,8192],
["Patrick Hand SC",3,8,8192],
["Pattaya",0,8,9224],
["Patua One",2,8,0],
["Pavanam",0,8,2048],
["Paytone One",0,8,8192],
["Peddana",1,8,4096],
["Peralta",1,8,0],
["Permanent Marker",3,8,0],
["Petemoss",3,8,8192],
["Petit Formal Script",3,8,0],
["Petrona",1,262143,8192],
["Phetsarath",0,72,0],
["Philosopher",0,36936,8200],
["Phudu",2,508,8192],
["Piazzolla",1,262143,8216],
["Piedra",2,8,0],
["Pinyon Script",3,8,8192],
["Pirata One",2,8,0],
["Pixelify Sans",2,120,8],
["Plaster",2,8,0],
["Platypi",1,129276,8192],
["Play",0,72,8216],
["Playball",2,8,8192],
["Playfair",1,260604,8200],
["Playfair Display",1,258552,8200],
["Playfair Display SC",1,168264,8200],
["Playpen Sans",3,255,8216],
["Playpen Sans Arabic",3,255,4],
["Playpen Sans Deva",3,255,2],
["Playpen Sans Hebrew",3,255,32],
["Playpen Sans Thai",3,255,1024],
["Playwrite AR",3,15,0],
["Playwrite AR Guides",3,8,0],
["Playwrite AT",3,7695,0],
["Playwrite AT Guides",3,4104,0],
["Playwrite AU NSW",3,15,0],
["Playwrite AU NSW Guides",3,8,0],
["Playwrite AU QLD",3,15,0],
["Playwrite AU QLD Guides",3,8,0],
["Playwrite AU SA",3,15,0],
["Playwrite AU SA Guides",3,8,0],
["Playwrite AU TAS",3,15,0],
["Playwrite AU TAS Guides",3,8,0],
["Playwrite AU VIC",3,15,0],
["Playwrite AU VIC Guides",3,8,0],
["Playwrite BE VLG",3,15,0],
["Playwrite BE VLG Guides",3,8,0],
["Playwrite BE WAL",3,15,0],
["Playwrite BE WAL Guides",3,8,0],
["Playwrite BR",3,15,0],
["Playwrite BR Guides",3,8,0],
["Playwrite CA",3,15,0],
["Playwrite CA Guides",3,8,0],
["Playwrite CL",3,15,0],
["Playwrite CL Guides",3,8,0],
["Playwrite CO",3,15,0],
["Playwrite CO Guides",3,8,0],
["Playwrite CU",3,15,0],
["Playwrite CU Guides",3,8,0],
["Playwrite CZ",3,15,0],
["Playwrite CZ Guides",3,8,0],
["Playwrite DE Grund",3,15,0],
["Playwrite DE Grund Guides",3,8,0],
["Playwrite DE LA",3,15,0],
["Playwrite DE LA Guides",3,8,0],
["Playwrite DE SAS",3,15,0],
["Playwrite DE SAS Guides",3,8,0],
["Playwrite DE VA",3,15,0],
["Playwrite DE VA Guides",3,8,0],
["Playwrite DK Loopet",3,15,0],
["Playwrite DK Loopet Guides",3,8,0],
["Playwrite DK Uloopet",3,15,0],
["Playwrite DK Uloopet Guides",3,8,0],
["Playwrite ES",3,15,0],
["Playwrite ES Deco",3,15,0],
["Playwrite ES Deco Guides",3,8,0],
["Playwrite ES Guides",3,8,0],
["Playwrite FR Moderne",3,15,0],
["Playwrite FR Moderne Guides",3,8,0],
["Playwrite FR Trad",3,15,0],
["Playwrite FR Trad Guides",3,8,0],
["Playwrite GB J",3,7695,0],
["Playwrite GB J Guides",3,4104,0],
["Playwrite GB S",3,7695,0],
["Playwrite GB S Guides",3,4104,0],
["Playwrite HR",3,15,0],
["Playwrite HR Guides",3,8,0],
["Playwrite HR Lijeva",3,15,0],
["Playwrite HR Lijeva Guides",3,8,0],
["Playwrite HU",3,15,0],
["Playwrite HU Guides",3,8,0],
["Playwrite ID",3,15,0],
["Playwrite ID Guides",3,8,0],
["Playwrite IE",3,15,0],
["Playwrite IE Guides",3,8,0],
["Playwrite IN",3,15,0],
["Playwrite IN Guides",3,8,0],
["Playwrite IS",3,15,0],
["Playwrite IS Guides",3,8,0],
["Playwrite IT Moderna",3,15,0],
["Playwrite IT Moderna Guides",3,8,0],
["Playwrite IT Trad",3,15,0],
["Playwrite IT Trad Guides",3,8,0],
["Playwrite MX",3,15,0],
["Playwrite MX Guides",3,8,0],
["Playwrite NG Modern",3,15,0],
["Playwrite NG Modern Guides",3,8,0],
["Playwrite NL",3,15,0],
["Playwrite NL Guides",3,8,0],
["Playwrite NO",3,15,0],
["Playwrite NO Guides",3,8,0],
["Playwrite NZ",3,15,0],
["Playwrite NZ Basic",3,15,0],
["Playwrite NZ Basic Guides",3,8,0],
["Playwrite NZ Guides",3,8,0],
["Playwrite PE",3,15,0],
["Playwrite PE Guides",3,8,0],
["Playwrite PL",3,15,0],
["Playwrite PL Guides",3,8,0],
["Playwrite PT",3,15,0],
["Playwrite PT Guides",3,8,0],
["Playwrite RO",3,15,0],
["Playwrite RO Guides",3,8,0],
["Playwrite SK",3,15,0],
["Playwrite SK Guides",3,8,0],
["Playwrite TZ",3,15,0],
["Playwrite TZ Guides",3,8,0],
["Playwrite US Modern",3,15,0],
["Playwrite US Modern Guides",3,8,0],
["Playwrite US Trad",3,15,0],
["Playwrite US Trad Guides",3,8,0],
["Playwrite VN",3,15,0],
["Playwrite VN Guides",3,8,0],
["Playwrite ZA",3,15,0],
["Playwrite ZA Guides",3,8,0],
["Pliant",0,262143,24],
["Plus Jakarta Sans",0,130302,8192],
["Pochaevsk",2,8,8],
["Podkova",1,248,8200],
["Poetsen One",2,8,0],
["Poiret One",2,8,8],
["Poller One",2,8,0],
["Poltawski Nowy",1,61560,8192],
["Poly",1,4104,0],
["Pompiere",2,8,0],
["Ponnala",2,8,4096],
["Ponomar",2,8,8],
["Pontano Sans",0,124,0],
["Poor Story",2,8,128],
["Poppins",0,262143,2],
["Port Lligat Sans",0,8,0],
["Port Lligat Slab",1,8,0],
["Potta One",2,8,8256],
["Pragati Narrow",0,72,2],
["Praise",3,8,8192],
["Prata",1,8,8200],
["Preahvihear",0,8,0],
["Press Start 2P",2,8,24],
["Pridi",1,126,9216],
["Princess Sofia",3,8,0],
["Prociono",1,8,0],
["Prompt",0,262143,9216],
["Prosto One",2,8,8],
["Protest Guerrilla",2,8,8192],
["Protest Revolution",2,8,8192],
["Protest Riot",2,8,8192],
["Protest Strike",2,8,8192],
["Proza Libre",0,127224,0],
["PT Mono",4,8,8],
["PT Sans",0,36936,8],
["PT Sans Caption",0,72,8],
["PT Sans Narrow",0,72,8],
["PT Serif",1,36936,8],
["PT Serif Caption",1,4104,8],
["Public Sans",0,262143,8192],
["Puppies Play",3,8,8192],
["Puritan",0,36936,0],
["Purple Purse",2,8,0],
["Qahiri",0,8,4],
["Quando",1,8,0],
["Quantico",0,36936,0],
["Quattrocento",1,72,0],
["Quattrocento Sans",0,36936,0],
["Questrial",0,8,8192],
["Quicksand",0,124,8192],
["Quintessential",3,8,0],
["Qwigley",3,8,8192],
["Qwitcher Grypen",3,72,8192],
["Racing Sans One",2,8,0],
["Radio Canada",0,63612,8192],
["Radio Canada Big",0,61560,0],
["Radley",1,4104,0],
["Rajdhani",0,124,2],
["Rakkas",2,8,4],
["Raleway",0,262143,8200],
["Raleway Dots",2,8,0],
["Ramabhadra",0,8,4096],
["Ramaraja",1,8,4096],
["Rambla",0,36936,0],
["Rammetto One",2,8,0],
["Rampart One",2,8,72],
["Ramsina",1,8,0],
["Ranchers",2,8,0],
["Rancho",3,8,0],
["Ranga",2,72,2],
["Rasa",1,63612,8192],
["Rationale",0,8,0],
["Ravi Prakash",2,8,4096],
["Readex Pro",0,126,8196],
["Recursive",0,508,8192],
["Red Hat Display",0,260604,0],
["Red Hat Mono",4,63612,0],
["Red Hat Text",0,63612,0],
["Red Rose",2,124,8192],
["Redacted",2,8,0],
["Redacted Script",2,76,0],
["Reddit Mono",4,510,8192],
["Reddit Sans",0,261630,8192],
["Reddit Sans Condensed",0,510,8192],
["Redressed",3,8,0],
["Reem Kufi",0,120,8196],
["Reem Kufi Fun",0,120,8196],
["Reem Kufi Ink",0,8,8196],
["Reenie Beanie",3,8,0],
["Reggae One",2,8,72],
["REM",0,262143,8192],
["Rethink Sans",0,127224,0],
["Revalia",2,8,0],
["Rhodium Libre",1,8,2],
["Ribeye",2,8,0],
["Ribeye Marrow",2,8,0],
["Righteous",2,8,0],
["Risque",2,8,0],
["Road Rage",2,8,8192],
["Roboto",0,262143,8216],
["Roboto Condensed",0,262143,8216],
["Roboto Flex",0,511,8216],
["Roboto Mono",4,65151,8216],
["Roboto Serif",1,262143,8200],
["Roboto Slab",1,511,8216],
["Rochester",3,8,0],
["Rock 3D",2,8,64],
["Rock Salt",3,8,0],
["RocknRoll One",0,8,64],
["Rokkitt",1,262143,8192],
["Romanesco",3,8,0],
["Ropa Sans",0,4104,0],
["Rosario",0,63612,8192],
["Rosarivo",1,4104,0],
["Rouge Script",3,8,0],
["Rowdies",2,76,8192],
["Rozha One",1,8,2],
["Rubik",0,260604,44],
["Rubik 80s Fade",2,8,40],
["Rubik Beastly",2,8,40],
["Rubik Broken Fax",2,8,40],
["Rubik Bubbles",2,8,40],
["Rubik Burned",2,8,40],
["Rubik Dirt",2,8,40],
["Rubik Distressed",2,8,40],
["Rubik Doodle Shadow",2,8,40],
["Rubik Doodle Triangles",2,8,40],
["Rubik Gemstones",2,8,40],
["Rubik Glitch",2,8,40],
["Rubik Glitch Pop",2,8,40],
["Rubik Iso",2,8,40],
["Rubik Lines",2,8,40],
["Rubik Maps",2,8,40],
["Rubik Marker Hatch",2,8,40],
["Rubik Maze",2,8,40],
["Rubik Microbe",2,8,40],
["Rubik Mono One",0,8,8],
["Rubik Moonrocks",2,8,40],
["Rubik Pixels",2,8,40],
["Rubik Puddles",2,8,40],
["Rubik Scribble",2,8,40],
["Rubik Spray Paint",2,8,40],
["Rubik Storm",2,8,40],
["Rubik Vinyl",2,8,40],
["Rubik Wet Paint",2,8,40],
["Ruda",0,504,8200],
["Rufina",1,72,0],
["Ruge Boogie",3,8,8192],
["Ruluko",0,8,0],
["Rum Raisin",0,8,0],
["Ruslan Display",2,8,8],
["Russo One",0,8,8],
["Ruthie",3,8,8192],
["Ruwudu",1,120,4],
["Rye",2,8,0],
["Sacramento",3,8,0],
["Sahitya",1,72,2],
["Sail",2,8,0],
["Saira",0,262143,8192],
["Saira Condensed",0,511,8192],
["Saira Extra Condensed",0,511,8192],
["Saira Semi Condensed",0,511,8192],
["Saira Stencil",2,262143,8192],
["Salsa",2,8,0],
["Sanchez",1,4104,0],
["Sancreek",2,8,0],
["Sankofa Display",0,8,8192],
["Sansation",0,38988,24],
["Sansita",0,233928,0],
["Sansita Swashed",2,508,8192],
["Sarabun",0,130815,9216],
["Sarala",0,72,2],
["Sarina",2,8,0],
["Sarpanch",0,504,2],
["Sassy Frass",3,8,8192],
["Satisfy",3,8,0],
["Savate",0,261630,0],
["Sawarabi Gothic",0,8,8264],
["Sawarabi Mincho",1,8,64],
["Scada",0,36936,8],
["Scheherazade New",1,120,4],
["Schibsted Grotesk",0,258552,0],
["Schoolbell",3,8,0],
["Science Gothic",0,511,8200],
["Scope One",1,8,0],
["Seaweed Script",2,8,0],
["Secular One",0,8,32],
["Sedan",1,4104,0],
["Sedan SC",1,8,0],
["Sedgwick Ave",3,8,8192],
["Sedgwick Ave Display",3,8,8192],
["Sekuya",2,8,0],
["Sen",0,248,0],
["Send Flowers",3,8,8192],
["Sevillana",2,8,0],
["Seymour One",0,8,8],
["Shadows Into Light",3,8,0],
["Shadows Into Light Two",3,8,0],
["Shafarik",2,8,8],
["Shalimar",3,8,8192],
["Shantell Sans",2,129276,8200],
["Shanti",0,8,0],
["Share",0,36936,0],
["Share Tech",0,8,0],
["Share Tech Mono",4,8,0],
["Shippori Antique",0,8,64],
["Shippori Antique B1",0,8,64],
["Shippori Mincho",1,248,64],
["Shippori Mincho B1",1,248,64],
["Shizuru",2,8,64],
["Shojumaru",2,8,0],
["Short Stack",3,8,0],
["Shrikhand",2,8,0],
["Siemreap",0,8,0],
["Sigmar",2,8,8192],
["Sigmar One",2,8,8192],
["Signika",0,124,8192],
["Signika Negative",0,124,8192],
["Silkscreen",2,72,0],
["Simonetta",2,135432,0],
["Single Day",2,8,128],
["Sintony",0,72,0],
["Sirin Stencil",2,8,0],
["Sirivennela",0,8,4096],
["Six Caps",0,8,0],
["Sixtyfour",4,8,0],
["Sixtyfour Convergence",4,8,0],
["Skranji",2,72,0],
["Slabo 13px",1,8,0],
["Slabo 27px",1,8,0],
["Slackey",2,8,0],
["Slackside One",3,8,64],
["Smokum",2,8,0],
["Smooch",3,8,8192],
["Smooch Sans",0,511,8192],
["Smythe",2,8,0],
["SN Pro",0,261630,8200],
["Sniglet",2,136,0],
["Snippet",0,8,0],
["Snowburst One",2,8,0],
["Sofadi One",2,8,0],
["Sofia",3,8,0],
["Sofia Sans",0,262143,24],
["Sofia Sans Condensed",0,262143,24],
["Sofia Sans Extra Condensed",0,262143,24],
["Sofia Sans Semi Condensed",0,262143,24],
["Solitreo",3,8,32],
["Solway",1,220,0],
["Sometype Mono",4,61560,0],
["Song Myung",1,8,128],
["Sono",0,254,8192],
["Sonsie One",2,8,0],
["Sora",0,255,0],
["Sorts Mill Goudy",1,4104,0],
["Sour Gummy",0,262143,0],
["Source Code Pro",4,261630,8216],
["Source Sans 3",0,261630,8216],
["Source Serif 4",1,261630,8216],
["Space Grotesk",0,124,8192],
["Space Mono",4,36936,8192],
["Special Elite",2,8,0],
["Special Gothic",0,120,0],
["Special Gothic Condensed One",0,8,0],
["Special Gothic Expanded One",0,8,0],
["Spectral",1,130302,8200],
["Spectral SC",1,130302,8200],
["Spicy Rice",2,8,0],
["Spinnaker",0,8,0],
["Spirax",2,8,0],
["Splash",3,8,8192],
["Spline Sans",0,124,0],
["Spline Sans Mono",4,63612,0],
["Squada One",2,8,0],
["Square Peg",3,8,8192],
["Sree Krushnadevaraya",1,8,4096],
["Sriracha",3,8,9216],
["Srisakdi",2,72,9216],
["Staatliches",2,8,0],
["Stack Sans Headline",0,126,0],
["Stack Sans Notch",0,126,0],
["Stack Sans Text",0,126,0],
["Stalemate",3,8,0],
["Stalinist One",2,8,8],
["Stardos Stencil",2,72,0],
["Stick",0,8,72],
["Stick No Bills",0,254,0],
["Stint Ultra Condensed",1,8,0],
["Stint Ultra Expanded",1,8,0],
["STIX Two Math",1,8,0],
["STIX Two Text",1,61560,8216],
["Stoke",1,12,0],
["Story Script",0,8,8192],
["Strait",0,8,0],
["Strichpunkt Sans",0,504,0],
["Style Script",3,8,8192],
["Stylish",0,8,128],
["Sue Ellen Francisco",3,8,0],
["Suez One",1,8,32],
["Sulphur Point",0,76,0],
["Sumana",1,72,2],
["Sunflower",0,84,128],
["Sunshiney",3,8,0],
["Supermercado One",2,8,0],
["Sura",1,72,2],
["Suranna",1,8,4096],
["Suravaram",1,8,4096],
["SUSE",0,262143,8192],
["SUSE Mono",0,130815,8192],
["Suwannaphum",1,333,0],
["Swanky and Moo Moo",3,8,0],
["Syncopate",0,72,0],
["Syne",0,248,16],
["Syne Mono",4,8,0],
["Syne Tactile",2,8,0],
["Tac One",0,8,8192],
["Tagesschrift",2,8,0],
["Tai Heritage Pro",1,72,8192],
["Tajawal",0,478,4],
["Tangerine",3,72,0],
["Tapestry",3,8,8192],
["Taprom",2,8,0],
["TASA Explorer",0,248,0],
["TASA Orbiter",0,248,0],
["Tauri",0,8,0],
["Taviraj",1,262143,9216],
["Teachers",0,127224,0],
["Teko",0,124,2],
["Tektur",2,504,8216],
["Telex",0,8,0],
["Tenali Ramakrishna",0,8,4096],
["Tenor Sans",0,8,8],
["Text Me One",0,8,0],
["Texturina",1,262143,8192],
["Thasadith",0,36936,9216],
["The Girl Next Door",3,8,0],
["The Nautigal",3,72,8192],
["Tienne",1,328,0],
["TikTok Sans",0,508,8216],
["Tillana",2,248,2],
["Tilt Neon",2,8,8192],
["Tilt Prism",2,8,8192],
["Tilt Warp",2,8,8192],
["Timmana",0,8,4096],
["Tinos",1,36936,8248],
["Tiny5",0,8,24],
["Tiro Bangla",1,4104,1],
["Tiro Devanagari Hindi",1,4104,2],
["Tiro Devanagari Marathi",1,4104,2],
["Tiro Devanagari Sanskrit",1,4104,2],
["Tiro Gurmukhi",1,4104,0],
["Tiro Kannada",1,4104,0],
["Tiro Tamil",1,4104,2048],
["Tiro Telugu",1,4104,4096],
["Tirra",0,504,0],
["Titan One",2,8,0],
["Titillium Web",0,56686,0],
["Tomorrow",0,262143,0],
["Tourney",2,262143,8192],
["Trade Winds",2,8,0],
["Train One",2,8,72],
["Triodion",2,8,8],
["Trirong",1,262143,9216],
["Trispace",0,255,8192],
["Trocchi",1,8,0],
["Trochut",2,4168,0],
["Truculenta",0,511,8192],
["Trykker",1,8,0],
["Tsukimi Rounded",0,124,64],
["Tuffy",0,36936,24],
["Tulpen One",2,8,0],
["Turret Road",2,222,0],
["Twinkle Star",3,8,8192],
["Ubuntu",0,47196,24],
["Ubuntu Condensed",0,8,24],
["Ubuntu Mono",4,36936,24],
["Ubuntu Sans",0,130815,24],
["Ubuntu Sans Mono",4,61560,24],
["Uchen",1,8,0],
["Ultra",1,8,0],
["Unbounded",0,510,8200],
["Uncial Antiqua",2,8,0],
["Underdog",2,8,8],
["Unica One",2,8,8192],
["UnifrakturCook",2,64,0],
["UnifrakturMaguntia",2,8,0],
["Unkempt",2,72,0],
["Unlock",2,8,0],
["Unna",1,36936,0],
["UoqMunThenKhung",1,8,520],
["Updock",3,8,8192],
["Urbanist",0,262143,0],
["Vampiro One",2,8,0],
["Varela",0,8,0],
["Varela Round",0,8,8224],
["Varta",0,124,8192],
["Vast Shadow",1,8,0],
["Vazirmatn",0,511,4],
["Vend Sans",0,63612,0],
["Vesper Libre",1,344,2],
["Viaoda Libre",2,8,8200],
["Vibes",2,8,4],
["Vibur",3,8,0],
["Victor Mono",4,65151,8216],
["Vidaloka",1,8,0],
["Viga",0,8,0],
["Vina Sans",2,8,8192],
["Voces",0,8,0],
["Volkhov",1,36936,0],
["Vollkorn",1,258552,8216],
["Vollkorn SC",1,360,8200],
["Voltaire",0,8,8192],
["VT323",4,8,8192],
["Vujahday Script",3,8,8192],
["Waiting for the Sunrise",3,8,0],
["Wallpoet",2,8,0],
["Walter Turncoat",3,8,0],
["Warnes",2,8,0],
["Water Brush",3,8,8192],
["Waterfall",3,8,8192],
["Wavefont",2,511,0],
["WDXL Lubrifont JP N",0,8,72],
["WDXL Lubrifont SC",0,8,264],
["WDXL Lubrifont TC",0,8,520],
["Wellfleet",1,8,0],
["Wendy One",0,8,0],
["Whisper",3,8,8192],
["WindSong",3,24,8192],
["Winky Rough",0,260604,0],
["Winky Sans",0,260604,0],
["Wire One",0,8,0],
["Wittgenstein",1,258552,0],
["Wix Madefor Display",0,248,8200],
["Wix Madefor Text",0,127224,8200],
["Work Sans",0,262143,8192],
["Workbench",4,8,0],
["Xanh Mono",4,4104,8192],
["Yaldevi",0,126,0],
["Yanone Kaffeesatz",0,126,8200],
["Yantramanav",0,349,2],
["Yarndings 12",2,8,0],
["Yarndings 12 Charted",2,8,0],
["Yarndings 20",2,8,0],
["Yarndings 20 Charted",2,8,0],
["Yatra One",2,8,2],
["Yellowtail",3,8,0],
["Yeon Sung",2,8,128],
["Yeseva One",2,8,8200],
["Yesteryear",3,8,0],
["Yomogi",3,8,8264],
["Young Serif",1,8,0],
["Yrsa",1,63612,8192],
["Ysabeau",0,262143,8216],
["Ysabeau Infant",0,262143,8216],
["Ysabeau Office",0,262143,8216],
["Ysabeau SC",0,511,8216],
["Yuji Boku",1,8,72],
["Yuji Hentaigana Akari",3,8,64],
["Yuji Hentaigana Akebono",3,8,64],
["Yuji Mai",1,8,72],
["Yuji Syuku",1,8,72],
["Yusei Magic",0,8,64],
["Yuyu",3,8,0],
["Yuyu Short",3,8,0],
["Zain",0,6606,4],
["Zalando Sans",0,261630,8192],
["Zalando Sans Expanded",0,261630,8192],
["Zalando Sans SemiExpanded",0,261630,8192],
["ZCOOL KuaiLe",0,8,256],
["ZCOOL QingKe HuangYou",0,8,256],
["ZCOOL XiaoWei",0,8,256],
["Zen Antique",1,8,88],
["Zen Antique Soft",1,8,88],
["Zen Dots",2,8,0],
["Zen Kaku Gothic Antique",0,348,72],
["Zen Kaku Gothic New",0,348,72],
["Zen Kurenaido",0,8,88],
["Zen Loop",2,4104,0],
["Zen Maru Gothic",0,348,88],
["Zen Old Mincho",1,376,88],
["Zen Tokyo Zoo",2,8,0],
["Zeyada",3,8,0],
["Zhi Mang Xing",3,8,256],
["Zilla Slab",1,63612,0],
["Zilla Slab Highlight",1,72,0]
];
